import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { FilesService } from 'app/services/files.service';
import { SharedService } from 'app/services/shared.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'checklist',
    templateUrl: 'checklist.component.html'
})
export class ChecklistComponent implements OnInit {
    @ViewChild('pdfViewer') pdfViewer;
    @Input('documentId') documentId: number;
    @Input('projectId') projectId: number; 
    public checkListName: string = 'mih-application-checklist.pdf';
    public checkListUploadedDate: string; 
    public InfoSrc: number = 0; 
    public pageError: any = [];
    
    constructor(private filesService: FilesService
        ,private sharedService: SharedService
        , private datePipe: DatePipe ) {
    }

    ngOnInit() {
        this.getCheckListDocumentByProjectId(this.projectId, this.checkListName);
        this.getCheckListInfo(this.projectId); 
    }


    getCheckListDocumentByProjectId(projectId: number, documentName: string) {
        this.filesService.getCheckListDocumentByProjectId(projectId)
            .subscribe(async (data: Blob) => {
                if (data && data.type == 'application/octet-stream') {
                    this.pdfViewer.pdfSrc = data;
                    this.pdfViewer.refresh();
                } else if (data && data.type == 'text/json') {
                    var errorMessage = await (new Response(data)).text();
                    if (errorMessage && errorMessage.length > 2) {
                        errorMessage = errorMessage.slice(1, -1);
                    }
                    this.showError(errorMessage);
                }
            });
    }

    getCheckListInfo(projectId: number) {
        this.filesService.getCheckListInfo(projectId)
            .subscribe(
            successResp => {
                if (successResp) {
                    if (successResp.Success) {
                        var data = successResp.Result;
                        if (data.DateTaken) {
                            this.checkListUploadedDate = this.formatDate(data.DateTaken)
                        }
                        this.InfoSrc = data.InfoSrc; 
                    }
                }
            },
            error => {
            });
    }


    showError(msg) {
        this.pageError = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }    

    formatDate(sDate) {
        var retDate = '';
        if (!sDate) {
            return '';
        }

        retDate = this.datePipe.transform(sDate, 'MM/dd/yyyy');
        return retDate;
    }

}